export default {
    'validation.string.alphanum': 'must only contain alpha-numeric characters',
    'validation.string.base': 'must be a string',
    'validation.string.base64': 'must be a valid base64 string',
    'validation.string.creditCard': 'must be a credit card',
    'validation.string.dataUri': 'must be a valid dataUri string',
    'validation.string.domain': 'must contain a valid domain name',
    'validation.string.email': 'must be a valid email',
    'validation.string.empty': 'not allowed to be empty',
    'validation.string.guid': 'must be a valid GUID',
    'validation.string.hex': 'must only contain hexadecimal characters',
    'validation.string.hexAlign': 'hex decoded representation must be byte aligned',
    'validation.string.hostname': 'must be a valid hostname',
    'validation.string.ip': 'must be a valid ip address with a {cidr} CIDR',
    'validation.string.ipVersion': 'must be a valid ip address of one of the following versions {version} with a {cidr} CIDR',
    'validation.string.isoDate': 'must be in iso format',
    'validation.string.isoDuration': 'must be a valid ISO 8601 duration',
    'validation.string.length': 'length must be {limit} characters long',
    'validation.string.lowercase': 'must only contain lowercase characters',
    'validation.string.max': 'length must be less than or equal to {limit} characters long',
    'validation.string.min': 'length must be at least {limit} characters long',
    'validation.string.normalize': 'must be unicode normalized in the {form} form',
    'validation.string.token': 'must only contain alpha-numeric and underscore characters',
    'validation.string.pattern.base': 'with value "{value}" fails to match the required pattern: {regex}',
    'validation.string.pattern.name': 'with value "{value}" fails to match the {name} pattern',
    'validation.string.pattern.invert.base': 'with value "{value}" matches the inverted pattern: {regex}',
    'validation.string.pattern.invert.name': 'with value "{value}" matches the inverted {name} pattern',
    'validation.string.trim': 'must not have leading or trailing whitespace',
    'validation.string.uri': 'must be a valid uri',
    'validation.string.uriCustomScheme': 'must be a valid uri with a scheme matching the {scheme} pattern',
    'validation.string.uriRelativeOnly': 'must be a valid relative uri',
    'validation.string.uppercase': 'must only contain uppercase characters',

    'validation.number.base': 'must be a number',
    'validation.number.greater': 'must be greater than {limit}',
    'validation.number.infinity': 'cannot be infinity',
    'validation.number.integer': 'must be an integer',
    'validation.number.less': 'must be less than {limit}',
    'validation.number.max': 'must be less than or equal to {limit}',
    'validation.number.min': 'must be larger than or equal to {limit}',
    'validation.number.multiple': 'must be a multiple of {multiple}',
    'validation.number.negative': 'must be a negative number',
    'validation.number.port': 'must be a valid port',
    'validation.number.positive': 'must be a positive number',
    'validation.number.precision': 'must have no more than {limit} decimal places',
    'validation.number.unsafe': 'must be a safe number',

    'validation.date.base': 'must be a valid date',
    'validation.date.format': 'must be in {format} format',
    'validation.date.greater': 'must be greater than "{limit}"',
    'validation.date.less': 'must be less than "{limit}"',
    'validation.date.max': 'must be less than or equal to "{limit}"',
    'validation.date.min': 'must be larger than or equal to "{limit}"',
    'validation.date.format.iso': 'ISO 8601 date',
    'validation.date.format.javascript': 'timestamp or number of milliseconds',
    'validation.date.format.unix': 'timestamp or number of seconds',

    'validation.alternatives.all': 'does not match all of the required types',
    'validation.alternatives.any': 'does not match any of the allowed types',
    'validation.alternatives.match': 'does not match any of the allowed types',
    'validation.alternatives.one': 'matches more than one allowed type',
    'validation.alternatives.types': 'must be one of {types}',

    'validation.any.custom': 'failed custom validation because {errorMessage}',
    'validation.any.default': 'threw an error when running default method',
    'validation.any.failover': 'threw an error when running failover method',
    'validation.any.invalid': 'contains an invalid value',
    'validation.any.only': 'must be one of {valids}',
    'validation.any.ref': '{arg} references "{ref}" which {reason}',
    'validation.any.required': 'is required',
    'validation.any.unknown': 'is not allowed',

    'validation.array.base': 'must be an array',
    'validation.array.excludes': 'contains an excluded value',
    'validation.array.hasKnown': 'does not contain at least one required match for type "{patternLabel}"',
    'validation.array.hasUnknown': 'does not contain at least one required match',
    'validation.array.includes': 'does not match any of the allowed types',
    'validation.array.includesRequiredBoth': 'does not contain {knownMisses} and {unknownMisses} other required value(s)',
    'validation.array.includesRequiredKnowns': 'does not contain {knownMisses}',
    'validation.array.includesRequiredUnknowns': 'does not contain {unknownMisses} required value(s)',
    'validation.array.length': 'must contain {limit} items',
    'validation.array.max': 'must contain less than or equal to {limit} items',
    'validation.array.min': 'must contain at least {limit} items',
    'validation.array.orderedLength': 'must contain at most {limit} items',
    'validation.array.sort': 'must be sorted in {order} order by {by}',
    'validation.array.sort.mismatching': 'cannot be sorted due to mismatching types',
    'validation.array.sort.unsupported': 'cannot be sorted due to unsupported type {type}',
    'validation.array.sparse': 'must not be a sparse array item',
    'validation.array.unique': 'contains a duplicate value',

    'validation.binary.base': 'must be a buffer or a string',
    'validation.binary.length': 'must be {limit} bytes',
    'validation.binary.max': 'must be less than or equal to {limit} bytes',
    'validation.binary.min': 'must be at least {limit} bytes',

    'validation.boolean.base': 'must be a boolean',

    'validation.function.arity': 'must have an arity of {n}',
    'validation.function.class': 'must be a class',
    'validation.function.maxArity': 'must have an arity lesser or equal to {n}',
    'validation.function.minArity': 'must have an arity greater or equal to {n}',

    'validation.object.and': 'contains {presentWithLabels} without its required peers {missingWithLabels}',
    'validation.object.assert': 'is invalid because the assertion failed',
    'validation.object.base': 'must be of type {type}',
    'validation.object.instance': 'must be an instance of "{type}"',
    'validation.object.length': 'must have {limit} fields',
    'validation.object.max': 'must have less than or equal to {limit} fields',
    'validation.object.min': 'must have at least {limit} fields',
    'validation.object.missing': 'must contain at least one of {peersWithLabels}',
    'validation.object.nand': '"{mainWithLabel}" must not exist simultaneously with {peersWithLabels}',
    'validation.object.oxor': 'contains a conflict between optional exclusive peers {peersWithLabels}',
    'validation.object.pattern.match': 'keys failed to match pattern requirements',
    'validation.object.refType': 'must be a Joi reference',
    'validation.object.regex': 'must be a RegExp object',
    'validation.object.rename.multiple': 'cannot rename "{from}" because multiple renames are disabled and another key was already renamed to "{to}"',
    'validation.object.rename.override': 'cannot rename "{from}" because override is disabled and target "{to}" exists',
    'validation.object.schema': 'must be a Joi schema of {type} type',
    'validation.object.unknown': 'is not allowed',
    'validation.object.with': '"{mainWithLabel}" missing required peer "{peerWithLabel}"',
    'validation.object.without': '"{mainWithLabel}" conflict with forbidden peer "{peerWithLabel}"',
    'validation.object.xor': 'contains a conflict between exclusive peers {peersWithLabels}',

    'validation.symbol.base': 'must be a symbol',
    'validation.symbol.map': 'must be one of {map}'
}